<template>
  <div class="input">
    <div class="input-group">
      <div class="input-label">説明</div>
      <textarea
        rows="3"
        class="input-textarea"
        v-model="description">
      </textarea>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    description: {
      get: function () {
        return this.$store.state.tourism.description
      },
      set: function (value) {
        this.$store.commit(
          'tourism/setDescription',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
